
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class AraziBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "AraziBasvuruSave";
    super(baseUrl);
  }


  saveAraziBasvuruSave(request: AraziBasvuruRequest){
    
    return this.post("", request, true);
   
  }

}
export default new AraziBasvuruAPI();
class AraziBasvuruRequest {
 
basvuruTuruId?:number;
sicilKodu?:number;
pafta?:string;
ada?:number;
parsel?:number;
mahalleKodu?:number;
caddeSokakKodu?:number;
mevki?:string;
tapuCiltNo?:number;
tapuSayfaNo?:number;
araziYüzolcumu?:number;
araziHisse?:number;
araziOran?:number;
arazi2Hisse?:number;
arazi2Oran?:number;
edinmeTarihi?:string;
aciklama?:string;
tapuYevmiyeTarihi?:string;
tapuYevmiyeNo?:string;
pismanlikIndirimi?:string;
imarPlanNo?:string;




  
  constructor(basvuruTuruId?:number,
    sicilKodu?:number,
    pafta?:string,
    ada?:number,
    parsel?:number,
    mahalleKodu?:number,
    caddeSokakKodu?:number,
    mevki?:string,
    tapuCiltNo?:number,
    tapuSayfaNo?:number,
    araziYüzolcumu?:number,
    araziHisse?:number,
    araziOran?:number,
    arazi2Hisse?:number,
    arazi2Oran?:number,
    edinmeTarihi?:string,
    aciklama?:string,
    tapuYevmiyeTarihi?:string,
    tapuYevmiyeNo?:string,
    pismanlikIndirimi?:string,
    imarPlanNo?:string,
    ) {
   
    this.basvuruTuruId = basvuruTuruId;
    this.sicilKodu = sicilKodu;
    this.pafta = pafta;
    this.ada = ada;
    this.parsel = parsel;
    this.mahalleKodu = mahalleKodu;
    this.caddeSokakKodu = caddeSokakKodu;
    this.mevki = mevki;
  
    this.tapuCiltNo = tapuCiltNo;
    this.tapuSayfaNo = tapuSayfaNo;

    this.araziYüzolcumu=araziYüzolcumu;
    this.araziHisse=araziHisse;
    this.araziOran=araziOran;
    this.arazi2Hisse=arazi2Hisse;
    this.arazi2Oran=arazi2Oran;
    this.edinmeTarihi=edinmeTarihi;
    this.aciklama=aciklama;
    this.tapuYevmiyeTarihi=tapuYevmiyeTarihi;
    this.tapuYevmiyeNo=tapuYevmiyeNo;
    this.pismanlikIndirimi=pismanlikIndirimi;
    this.imarPlanNo=imarPlanNo;


 
      

  }
}
export { AraziBasvuruRequest };
/*
*/



